// extracted by mini-css-extract-plugin
export default {"container":"UserProfile_container__ZVVMg","btnsWrapper":"UserProfile_btnsWrapper__XUQna","wrapperOrders":"UserProfile_wrapperOrders__cgd9g","link":"UserProfile_link__4wVwO"};